import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsMenuService } from '@app/modules/settings/services/settings-menu.service';
import { FieldsIndexTable } from '@app/modules/settings/services/tables/fields-table/fields-index.table';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views';
import { DataField } from '@models/settings/data-field.model';

@Component({
    templateUrl: './fields-index.template.html',
    styleUrls: ['./fields-index.style.scss'],
})
export class FieldsIndexView extends IndexView {
    isLoading = false;

    fields: DataField[] = [];

    currentField: DataField = new DataField();

    isDeleteModalOpen = false;

    constructor(
        public auth: AuthService,
        public fieldsIndexTable: FieldsIndexTable,
        private router: Router,
        private notify: NotifyService,
        public settingsMenuService: SettingsMenuService
    ) {
        super();
        this.fieldsIndexTable.onLoading.subscribe((isLoading) => (this.isLoading = isLoading));
        this.fieldsIndexTable.reload();
    }

    async onTableMenuEvent(event: MenuColumnEvent): Promise<void> {
        const eventType = event.menuItem.event;
        this.currentField = event.data as DataField;

        switch (eventType) {
            case 'edit':
                this.router.navigate(['/settings', 'custom-fields', 'fields', this.currentField.id, 'edit']);
                break;
            case 'assign':
                this.router.navigate([
                    '/settings',
                    'custom-fields',
                    'fields',
                    this.currentField.id,
                    'assign-employees',
                ]);
                break;
            case 'delete':
                this.isDeleteModalOpen = true;
                break;
        }
    }

    async onDelete(): Promise<void> {
        this.isLoading = true;

        try {
            await this.currentField.param('company', this.auth.company.id).delete();

            this.notify.success('settings.custom-fields.customFieldDeletedMessage');
            this.isDeleteModalOpen = false;
            this.fieldsIndexTable.reload();
        } catch (err) {
            this.notify.error(err.message);
        } finally {
            this.isLoading = false;
        }
    }
}
